<template>
  <div id="full-input-size">
    <NxInput
      name="nome"
      type="text"
      label="Cooperativa:"
      placeholder="Digite o nome da cooperativa"
      :value="localValue"
      @update:value="handleValueUpdate"
    ></NxInput>
  </div>
</template>

<script>
import { useReactiveModelMixin } from '../../mixins'
export default {
  name: 'NxInputCooperativa',
  mixins: [useReactiveModelMixin('value')],
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>

<style lang="scss">
#full-input-size {
  .formulate-input {
    margin-bottom: 0px;

    .formulate-input-element {
      max-width: none;

      textarea {
        height: 7rem;
        border-radius: 0.3rem 0.3rem 0px 0px;
        resize: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputCooperativa.vue